// 유저 vuex
const userStore = {
  namespaced: true,

  state: {
    userInfo: {
      UserID: '',
      UserName: '',
      EmployeeNumber: '',
      Password: '',
      ManageGName: '',
      ManageGCode: '',
      Department: '',
      AuthNoticeView: 0,
      AuthNoticeWrite: 0,
      AuthRequestView: 0,
      AuthRequestWrite: 0,
      AuthIncongruityView: 0,
      AuthIncongruityWrite: 0,
      AuthLibraryTestWrite: 0,
      AuthLibraryTestView: 0,
      AuthNewClientConfirm: 0,
      TeamCode: '',
      IsSimpleAuth: false,
      IsHeadquarter: '',
      IsAdministrators: '',
      IsAdmin: false,
      Token: ''
    },
    toAdmin: false,
    isPinResetToSimpleAuth: false,
    pushOption: {
      IsReceivePush: '',
      amTime: '',
      pmTime: ''
    }
  },

  getters: {
    getUserInfo (state) {
      return state.userInfo
    },
    getUserID: state => state.userInfo.UserID,
    getPassword: state => state.userInfo.Password,
    getPushOption: state => state.pushOption,
    getToAdmin: state => state.toAdmin,
    getIsPinResetAuthToSimpleAuth: state => state.isPinResetToSimpleAuth
  },

  mutations: {
    mutationUserInfo: (state, payload) => {
      state.userInfo = payload
    },

    mutationNewClinetConfirm: (state, payload) => {
      state.userInfo.AuthNewClientConfirm = payload
    },

    mutationPushOption: (state, payload) => {
      state.pushOption = payload
    },

    mutationToAdmin: (state, payload) => {
      state.toAdmin = payload
    },

    mutationIsPinResetAuthToSimpleAuth: (state, payload) => {
      state.isPinResetToSimpleAuth = payload
    },

    mutatinResetUserINfo: (state) => {
      state.userInfo = {
        UserID: '',
        UserName: '',
        EmployeeNumber: '',
        Password: '',
        ManageGName: '',
        ManageGCode: '',
        Department: '',
        AuthNoticeView: 0,
        AuthNoticeWrite: 0,
        AuthRequestView: 0,
        AuthRequestWrite: 0,
        AuthIncongruityView: 0,
        AuthIncongruityWrite: 0,
        AuthLibraryTestWrite: 0,
        AuthLibraryTestView: 0,
        AuthNewClientConfirm: 0,
        TeamCode: '',
        IsSimpleAuth: false,
        IsHeadquarter: '',
        IsAdministrators: '',
        IsAdmin: false,
        Token: ''
      }
      state.pushOption = {
        IsReceivePush: '',
        amTime: '',
        pmTime: ''
      }
    }
  },

  actions: {
    actionUserInfo: ({ commit }, payload) => {
      commit('mutationUserInfo', payload)
    }
  }
}

export default userStore
